<template>
  <div class="bar">
    <div @click="() => {isOpen = !isOpen;$emit('open', isOpen)}">
      <span>{{label}}</span>
      <svg class="icon" :class="{open: isOpen}" aria-hidden="true">
        <use xlink:href="#icon-arrow-right"></use>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Bar',
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false
    }
  }
}
</script>
<style scoped lang="less">
.bar{
  width: 100%;
  padding: 0 .28rem;
  >div{
    padding: .36rem 0 .16rem;
    font-size: 16px;
    line-height: 20px;
    border-bottom: 1px solid #6D7278;
    display: flex;
    justify-content: space-between;
    color: #081530;
    svg{
      color: #444;
      &.open{
        transform: rotate(90deg);
      }
    }
  }
}
</style>
